import React from "react";
import { Button } from "primereact/button";
// import { Tooltip } from "primereact/tooltip";
import { getFileName } from "app/utils/utils";
import FileTypeIcon from "app/assets/IconComponent/FileTypeIcon";

interface FileViewComponentProps {
  docPath: string;
  canDelete?: boolean;
  onDelete?: () => void;
  onClick?: (docPath: string) => void;
  disabled?: boolean;
}

const FileViewComponent: React.FC<FileViewComponentProps> = ({
  docPath,
  canDelete = false,
  onDelete,
  onClick,
  disabled = false,
}) => (
  <div
    className="flex items-center justify-between p-2 bg-gray-100 dark:!bg-blue-1100 rounded-md cursor-pointer file-view-item"
    onClick={(e) => {
      e.stopPropagation();
      onClick && onClick(docPath);
    }}
  >
    <div className="flex items-center">
      <FileTypeIcon type={docPath} width={30} height={30} />
      <div className="ml-3">
        <div className="font-semibold">{getFileName(docPath)}</div>
      </div>
    </div>
    <div className="flex items-center">
      {canDelete && (
        <div
          className={disabled ? "cursor-not-allowed" : ""}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <Button
            icon="pi pi-times"
            size="small"
            disabled={disabled}
            rounded
            className="ml-2 p-button-rounded !h-[2rem] !w-[2rem] py-1.5 px-3 text-white text-2xl !bg-light-gray p-button-text delete-button"
            aria-label="Delete"
            onClick={(e) => {
              e.stopPropagation();
              onDelete && onDelete();
            }}
          />
        </div>
      )}
    </div>
  </div>
);

export default FileViewComponent;
